import { mockCustomerDetails } from '@domgen/dgx-fe-common';
import { formatProvinceCode, USProvinceName } from '@domgen/dgx-fe-i18n';
import { PaysafeShippingAddress } from '../../models/paysafe/paysafe-shipping-address.interface';

export const mockPaysafeShippingDetails: PaysafeShippingAddress = {
  city: mockCustomerDetails.address.addressLine3,
  country: mockCustomerDetails.address.countryIso2,
  state: formatProvinceCode(
    mockCustomerDetails.address.addressLine4,
    USProvinceName
  ),
  street: mockCustomerDetails.address.addressLine1,
  street2: mockCustomerDetails.address.addressLine2,
  zip: mockCustomerDetails.address.postalCode,
};
